/*
 * @Author: your name
 * @Date: 2019-11-21 18:30:52
 * @LastEditTime: 2023-10-23 10:22:39
 * @LastEditors: mqlpcthree mql_pcthree@163.com
 * @Description: In User Settings Edit
 * @FilePath: /mei_qi_zeroweb_endlyq/src/router/home/money.js
 */
// money
const index = () => import(/* webpackChunkName: 'homeIndex' */ '@views/home/index/index')

// const MqlMiddlePage = () =>
//   import(/* webpackChunkName: 'memberList' */ '@components/core/MqlLayout/MqlMiddlePage/index')
const moneyBill = () =>
  import(/* webpackChunkName: 'moneyBill' */ '@views/home/money/moneyBill/index')
const moneyStore = () =>
  import(/* webpackChunkName: 'moneyStore' */ '@views/home/money/moneyStore/index')
const moneyConsumeCard = () =>
  import(/* webpackChunkName: 'moneyConsumeCard' */ '@views/home/money/moneyConsumeCard/index')
const moneyTimeCard = () =>
  import(/* webpackChunkName: 'moneyTimeCard' */ '@views/home/money/moneyTimeCard/index')
const moneyOpenCard = () =>
  import(/* webpackChunkName: 'moneyOpenCard' */ '@views/home/money/moneyOpenCard/index')
const monetStatement = () =>
  import(/* webpackChunkName: 'monetStatement' */ '@views/home/money/monetStatement/index')
const moneyProjectReport = () =>
  import(/* webpackChunkName: 'moneyProjectReport' */ '@views/home/money/moneyProjectReport/index')
const Pointsdetails = () =>
  import(/* webpackChunkName: 'moneyProduct' */ '@/views/home/money/Pointsdetails/index')
const moneyProduct = () =>
  import(/* webpackChunkName: 'moneyProduct' */ '@views/home/money/moneyProduct/index')

const routes = [
  {
    path: '/money',
    component: index,
    redirect: { name: 'homeMoneyStore' },
    hidden: true,
    name: 'money',
    meta: {
      keepAlive: true,
      title: '门店业绩',
      icon: 'money_manage',
      first: true,
      resourceCode: 'MONEY_MANAGE',
      No: 4
    },
    children: [
      {
        path: 'money/store',
        component: moneyStore,
        name: 'homeMoneyStore',
        meta: {
          keepAlive: true,
          title: '门店账单',
          second: false,
          resourceCode: 'MONEY_MANAGE01',
          No: 0
        }
      },
      {
        path: 'bill',
        component: moneyBill,
        name: 'homemMoneyBill',
        meta: {
          keepAlive: true,
          title: '门店资金',
          second: false,
          resourceCode: 'MONEY_MANAGE02',
          No: 1
        }
      },
      {
        path: 'money/consumeCard',
        component: moneyConsumeCard,
        name: 'homeMoneyConsumeCard',
        meta: {
          keepAlive: true,
          title: '充值耗卡',
          second: false,
          resourceCode: 'MONEY_MANAGE03',
          No: 2
        }
      },
      {
        path: 'money/timeCard',
        component: moneyTimeCard,
        name: 'homeMoneyTimeCard',
        meta: {
          keepAlive: true,
          title: '次卡耗卡',
          second: false,
          resourceCode: 'MONEY_MANAGE04',
          No: 3
        }
      },
      {
        path: 'money/openCard',
        component: moneyOpenCard,
        name: 'homeMoneyOpenCard',
        meta: {
          keepAlive: true,
          title: '开卡明细',
          second: false,
          resourceCode: 'MONEY_MANAGE05',
          No: 4
        }
      },
      {
        path: 'money/statement',
        component: monetStatement,
        name: 'homeMonetStatement',
        meta: {
          keepAlive: true,
          title: '支出明细',
          second: false,
          resourceCode: 'MONEY_MANAGE06',
          No: 5
        }
      },
      {
        path: 'money/Pointsdetails',
        component: Pointsdetails,
        name: 'Pointsdetails',
        meta: {
          keepAlive: true,
          title: '积分明细',
          second: false,
          resourceCode: 'MONEY_MANAGE09',
          No: 8
        }
      },
      {
        path: 'money/ProjectReport',
        component: moneyProjectReport,
        name: 'homeMoneyProjectReport',
        meta: {
          keepAlive: true,
          title: '项目业绩报表',
          second: false,
          resourceCode: 'MONEY_MANAGE07',
          No: 6
        }
      },
      {
        path: 'money/Product',
        component: moneyProduct,
        name: 'homeMoneyProduct',
        meta: {
          keepAlive: true,
          title: '产品业绩报表',
          second: false,
          resourceCode: 'MONEY_MANAGE08',
          No: 7
        }
      }
    ]
  }
]

export default {
  routes
}



// WEBPACK FOOTER //
// ./src/router/home/money.js